import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          创作者口碑
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">听听创作者们怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-[oklch(var(--primary-500)/0.3)]"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < t.rating
                        ? 'ri-star-fill text-[oklch(var(--secondary-500))]'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-3">
                &ldquo;{t.content}&rdquo;
              </p>

              <div className="flex items-center gap-3">
                <img
                  src={t.userAvatar}
                  alt={t.userName}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{t.userName}</p>
                  <p className="text-xs text-foreground-500 truncate">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}